
import { useState } from "react";
import MarketplaceContainer from "./marketplace/MarketplaceContainer";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ShoppingBag, Filter, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

const Marketplace = () => {
  const [selectedView, setSelectedView] = useState<"services" | "products">("services");

  return (
    <div className="container mx-auto px-4 py-8 animate-fade-in">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gradient mb-2">Marketplace</h1>
          <p className="text-gray-600">Find services, products, and resources from the DGK community</p>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="flex p-1 bg-gray-100 rounded-lg">
            <Button 
              variant={selectedView === "services" ? "default" : "ghost"}
              className={selectedView === "services" ? "bg-gradient-to-r from-sky-500 to-emerald-500" : ""}
              onClick={() => setSelectedView("services")}
            >
              Services
            </Button>
            <Button 
              variant={selectedView === "products" ? "default" : "ghost"}
              className={selectedView === "products" ? "bg-gradient-to-r from-sky-500 to-emerald-500" : ""}
              onClick={() => setSelectedView("products")}
            >
              Products
            </Button>
          </div>
          
          <Link to="/submit-service">
            <Button className="bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600">
              <ShoppingBag className="w-4 h-4 mr-2" />
              Sell a Service
            </Button>
          </Link>
        </div>
      </div>
      
      <div className="mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 bg-gradient-to-r from-sky-50 to-emerald-50 p-4 rounded-lg">
        <Badge className="bg-sky-100 text-sky-800 py-1.5 px-3">
          <DollarSign className="w-4 h-4 mr-1" />
          New Seller Promo: 0% commission until June
        </Badge>
        
        <Badge className="bg-emerald-100 text-emerald-800 py-1.5 px-3">
          <Filter className="w-4 h-4 mr-1" />
          Top rated freelancers available
        </Badge>
      </div>

      <MarketplaceContainer selectedView={selectedView} />
    </div>
  );
};

export default Marketplace;
